import { lazy } from 'react';
import Loadable from '../../components/Loadable';
import { CategoryProvider } from "../../contexts/categoryContext/CategoryContext";
import { SubCategoryProvider } from "../../contexts/categoryContext/SubCategoryContext";
import BrandsFragments from './views/BrandsList';

const CategoryFragment = Loadable(lazy(() => import('./views/CategoryFragment')));
const SubCategoryFragment = Loadable(lazy(() => import('./views/SubCategoryFragment')));
const AddCategoryFragment = Loadable(lazy(() => import('./views/AddCategoryFragment')));
const AddSubCategoryFragment = Loadable(lazy(() => import('./views/AddSubCategoryFragment')));

const categoriesRoutes = [
  { path: '/add_category', element: <CategoryProvider><AddCategoryFragment /></CategoryProvider> },
  { path: '/edit_category/:id', element: <CategoryProvider><AddCategoryFragment /></CategoryProvider> },
  { path: '/category', element: <CategoryProvider><CategoryFragment /></CategoryProvider> },
  { path: '/subCategory', element: <SubCategoryProvider><SubCategoryFragment /></SubCategoryProvider> },
  { path: '/add_sub_category', element: <SubCategoryProvider><AddSubCategoryFragment /></SubCategoryProvider> },
  { path: '/brands', element: <SubCategoryProvider><BrandsFragments /></SubCategoryProvider> },
  { path: '/edit_sub_category/:id', element: <SubCategoryProvider><AddSubCategoryFragment /></SubCategoryProvider> },
];

export default categoriesRoutes;
